import { Box, Stack, StackProps, useTheme } from '@mui/material';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { FractionDigitsFormattedNumber, PoolActionLabel, PoolRow } from '@synergy/components-next';
import { PoolMath } from '@synergy/utils';
import { ReactElement } from 'react';

import { WishListArticle } from '../../../../models/wish-list';

export interface SupplierTableRowProps extends StackProps {
    article: WishListArticle;
    netPrice: number;
}

export const ArticlePrice = (props: SupplierTableRowProps): ReactElement => {
    const theme = useTheme();
    const { article, netPrice, ...stackProps } = props;

    return (
        <Stack justifyContent="flex-end" typography="body2" width={129} marginLeft="auto" {...stackProps}>
            <Box
                color={article.specialPrice ? theme.palette.error.dark : theme.palette.common.black}
                typography="body1"
            >
                <FractionDigitsFormattedNumber value={netPrice} currency={article.currency} />
            </Box>

            {article.specialPrice && (
                <PoolRow justifyContent="flex-end">
                    <Box sx={{ textDecoration: 'line-through' }}>
                        <FormattedNumber value={article.mainPrice} currency={article.currency} style="currency" />
                    </Box>
                    <Box color={theme.palette.error.dark} marginLeft={0.5}>
                        <FormattedNumber
                            value={-PoolMath.getPercentDifference(article.mainPrice, article.specialPrice.price)}
                            style="percent"
                        />
                    </Box>
                </PoolRow>
            )}

            {article.isBestPrice && (
                <Box sx={{ my: 0.5 }}>
                    <PoolActionLabel variant="small" color="secondary" hasSkew={false} sx={{ width: 'fit-content' }}>
                        <FormattedMessage id="app.filter.bestprice" />
                    </PoolActionLabel>
                </Box>
            )}

            {article.contentUnit && (
                <Box color="grey.700">
                    &nbsp;(
                    <FractionDigitsFormattedNumber
                        value={(article.specialPrice?.price ?? article.mainPrice) / (article.contentQuantity ?? 1)}
                        currency={article.currency}
                    />
                    &nbsp;/&nbsp;
                    {article.contentUnit})
                </Box>
            )}
        </Stack>
    );
};
